import { type AcceptQuotePayload } from '../../../modules/moves'
import { type CheckoutFormValues } from './CheckoutForm.type'

export const formatFormOutput = (values: CheckoutFormValues): AcceptQuotePayload => {
  return {
    selectedTime: values.selectedTime,
    note: values.note !== '' ? values.note : undefined,
  }
}
